import {DialogContent, Stack, Typography} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import type {GetCustomerPopupsResponse} from '@resurs-internal/rb-app-api';
import React from 'react';

type Content = NonNullable<
  GetCustomerPopupsResponse['popups'][number]['content']['information']
>;

interface Props {
  content: Content;
  onConfirm: () => void;
  onClose: () => void;
  isPending: boolean;
}

export const PopupInformationDialog: React.FC<Props> = ({
  content,
  onConfirm,
  onClose,
  isPending,
}) => {
  return (
    <BaseDialog
      open
      image={content.image}
      onClose={onClose}
      actions={[
        {
          title: content.buttonText,
          color: 'primary',
          onClick: onConfirm,
          disabled: isPending,
        },
      ]}>
      <DialogContent>
        <Stack alignItems="center" gap={2}>
          <Typography typography="h2">{content.title}</Typography>
          <Typography typography="body1">{content.body}</Typography>
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
